<!-- app/assets/javascript/components/admin/analytics/logins_chart.vue -->
<template>
  <div class="w-full">
    <svg :viewBox="`0 0 ${width} ${height}`" class="w-full" role="img" aria-label="Logins and active users over time">
      <polyline :points="loginPoints" fill="none" stroke="#0d9488" stroke-width="2" />
      <polyline :points="activePoints" fill="none" stroke="#6366f1" stroke-width="2" stroke-dasharray="4 3" />
    </svg>
    <div class="mt-2 flex gap-4 text-xs">
      <span class="text-teal-700">— Logins</span>
      <span class="text-indigo-600">-- Active users</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { linePoints } from './logins_chart_points'

const props = defineProps({ series: { type: Array, default: () => [] } })
const width = 640
const height = 180
const pad = 24

const logins = computed(() => props.series.map((r) => r.logins))
const actives = computed(() => props.series.map((r) => r.active_users))
const max = computed(() => Math.max(1, ...logins.value, ...actives.value))

const loginPoints = computed(() => linePoints(logins.value, { width, height, pad, max: max.value }))
const activePoints = computed(() => linePoints(actives.value, { width, height, pad, max: max.value }))
</script>
